import React from 'react'
import Slider from 'react-slick'
import { SVGComponent } from '../..'

const SkippableBannerPWA = ({ isSticky, isPwa, toggle }) => {
  const imageArray = [
    {
      /* eslint-disable indent */
      url:
        'https://qaui.cltp.co/offermgmt/images/slider2.png'
    },
    {
      /* eslint-disable indent */
      url:
        'https://qaui.cltp.co/offermgmt/images/slider3.png'
    }
  ]

  return (
    <>
      <div className="bg-orange-100 login-banner">
        {!isSticky && isPwa && (
        <div className="pl-20 pt-20" onClick={toggle}>
          <SVGComponent svgIcon="sliderClose" />
        </div>
          )}

        <div
          className="bg-orange-100 login-banner"
          style={{
              width: 'calc(100% )',
              maxWidth: isPwa ? '100vw' : '410px',
              overflow: 'hidden',
              height: isPwa ? 'auto' : '437px',
              paddingTop: isPwa ? '0px' : '88px'
            }}
        >
          <Slider
            dots={true}
            infinite={true}
            speed={500}
            slidesToShow={1}
            initialSlide={0}
            slidesToScroll={1}
            arrows={false}
            autoplay={true}
            appendDots={dots => <ul>{dots}</ul>}
            customPaging={i => <div className="ft-slick__dots--custom" />}
          >
            {imageArray?.map(item => (
              <div className="flex">
                <div>
                  <div
                    className="centered w-100vw"
                    style={{ marginTop: '-74px' }}
                  />
                  <img
                    width="100%"
                    src={item?.url}
                    alt="offer banner"
                    className="slider-bannerpwa-image mt-15"
                  />
                </div>
              </div>
              ))}
          </Slider>
        </div>
      </div>
    </>
  )
}

export default SkippableBannerPWA
